import { useLayoutEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { useNetworkStatus } from "../../../../contexts/NetworkContext"; // Import hook
function SystemManage(props) {
    const navigate = useNavigate();
    const { isOnline } = useNetworkStatus(); // Lấy biến isOnline từ context
    let users = "";
    const userStr = window.getFromStorage("user-info");
    if (userStr === "null") navigate("/login");
    else users = JSON.parse(userStr);

    const [menuList, setMenuList] = useState([]);
    async function getMenu(reload = 0) {
        if ((await window.indexDB.isStoreEmpty("tbl_menu", users.id)) || reload === 1) {
            window.indexDB.clearStore("tbl_menu", users.id); //// lam sach menu trong indexDB
            window.indexDB.clearStore("my_function_permission", users.id);
            const promise = new Promise((resolve, reject) => {
                resolve(window.fetchWithAuth("module_permission/getMenuSideBar/0").then((response) => response.json()));
            }).then((results) => {
                if (results.code == 401) {
                    navigate("/logout");
                }
                setMenuList(results.data);
                window.indexDB.saveAllStore("tbl_menu", results.data, users.id);
                window.indexDB.saveAllStore("my_function_permission", results.data_function_permission, users.id);
            });
            return promise;
        } else {
            const storedData = await window.indexDB.getAllStore("tbl_menu", users.id); // ❗ Cần await ở đây
            setMenuList(storedData);
        }
    }
    useLayoutEffect(() => {
        trackPromise(getMenu(0));
        ////auto set menu active
        window.$('[data-widget = "treeview"]').Treeview("init");
        window.$(document).on("click", '[data-widget="treeview"] .nav-link', function (e) {
            e.stopImmediatePropagation();
        });
        ////end set menu active
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function Menu(items, level = 0) {
        if (level === 0) {
            return items.map((item) => (
                <li key={item.id} className="nav-item" >
                    <Link to={item.name_module} className={item.id === 1 ? "nav-link" : "nav-link"} style={{color: "white"}}>
                        <i className={item.path_icon}></i>
                        <p>
                            {item.name}
                            <i className="right fas fa-angle-left" />
                        </p>
                    </Link>
                    {item.children && Menu(item.children, 1)}
                </li>
            ));
        }
        if (level > 0) {
            return (
                <ul className="nav nav-treeview">
                    {items.map((item) => (
                        <li key={item.id} className="nav-item" >
                            <Link to={item.name_module} className="nav-link" style={{color: "white"}}>
                                <i className={item.path_icon}></i>
                                <p>
                                    {item.name}
                                    {item.end === 0 && <i className="right fas fa-angle-left" />}
                                </p>
                            </Link>
                            {item.children && Menu(item.children, item.level)}
                        </li>
                    ))}
                </ul>
            );
        }
    }
    return (
        <ul className="nav nav-pills nav-sidebar flex-column nav-child-indent" data-widget="treeview" role="menu" data-accordion="false">
            <li className="nav-item">
                <Link className="nav-link" to={"./"} style={{color: "white"}}>
                    <i className="fas fa-home nav-icon"></i>
                    <p>Dashboard</p>
                </Link>
            </li>
            {Menu(menuList)}
            {isOnline && (
                <li className="nav-item" style={{ cursor: "pointer" }}>
                    <span className="nav-link" onClick={() => getMenu(1)}>
                        <i className="fas fa-redo-alt nav-icon text-success"></i>
                        <p>Cập nhật lại menu</p>
                    </span>
                </li>
            )}
        </ul>
    );
}

export default SystemManage;
